"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const container_1 = require("../container");
const theme_provider_1 = require("../theme-provider");
const StyledFigure = theme_provider_1.styled.figure.withConfig({ displayName: "StyledFigure", componentId: "sc-12ow4v1" }) `
	margin: 0;
`;
StyledFigure.displayName = 'StyledFigure';
exports.Figure = props => {
    const { caption, captionAboveMedia, children } = props;
    return (React.createElement(StyledFigure, null,
        React.createElement(container_1.Container, { gutter: container_1.ContainerGutter.dynamic0020, wrap: container_1.ContainerWrap.always },
            caption && captionAboveMedia && React.createElement("figcaption", null, caption),
            children,
            caption && !captionAboveMedia && React.createElement("figcaption", null, caption))));
};
exports.Figure.displayName = 'Figure';
